export default __webpack_public_path__ + "static/media/risk.8d1e492a.svg";